import { render, staticRenderFns } from "./TreeNote.vue?vue&type=template&id=2d632fe8&"
import script from "./TreeNote.vue?vue&type=script&lang=js&"
export * from "./TreeNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports